import { isBrowser } from "./browserUtils"

export default function getLangRoute(lang) {
    const queryParams = isBrowser ? window.location.search : ''
    if (lang === "en") {
        return `${window.location?.pathname?.replace('/hi', '')}${queryParams}`
    } else if (!window.location?.pathname?.includes('/hi')){
        return `/hi${window.location?.pathname}${queryParams}`
    }
}